import {useState} from "react";
import "./authentication.styles.scss";
import SignInForm from "../../components/sign-in-form/sign-in-form.component";
import SignUpForm from "../../components/sign-up-form/sign-up-form.component";
import logo from "../../assets/suraj-logo.png";

const Authentication = () => {
  const [mode, setMode] = useState("signin");
  const isSignIn = mode === "signin";

  return (
    <div className="auth-page">
      <div className="auth-card">
        <aside className="auth-brand">
          <img src={logo} alt="Suraj Verma logo" className="auth-logo"/>
          <h2>Welcome to the journal.</h2>
          <p>
            Sign in to write and manage blog posts, or create an account to
            join in.
          </p>
          <span className="auth-brand-badge">Suraj Verma · Portfolio</span>
        </aside>

        <div className="auth-panel">
          <div className="auth-tabs" role="tablist">
            <button
              type="button"
              role="tab"
              aria-selected={isSignIn}
              className={isSignIn ? "active" : ""}
              onClick={() => setMode("signin")}
            >
              Sign In
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={!isSignIn}
              className={!isSignIn ? "active" : ""}
              onClick={() => setMode("signup")}
            >
              Create Account
            </button>
          </div>

          <h1 className="auth-heading">
            {isSignIn ? "Welcome back" : "Create your account"}
          </h1>
          <p className="auth-sub">
            {isSignIn
              ? "Sign in to continue to your journal."
              : "It only takes a moment to get started."}
          </p>

          {isSignIn ? <SignInForm/> : <SignUpForm/>}
        </div>
      </div>
    </div>
  );
};

export default Authentication;
